module.exports = __webpack_public_path__ + "img/card-5.50ad2b3e.png";